import { render, staticRenderFns } from "./LandingHeadline.vue?vue&type=template&id=2d9be5f9&scoped=true"
import script from "./LandingHeadline.vue?vue&type=script&lang=js"
export * from "./LandingHeadline.vue?vue&type=script&lang=js"
import style0 from "./LandingHeadline.vue?vue&type=style&index=0&id=2d9be5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9be5f9",
  null
  
)

export default component.exports